import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-common',
  templateUrl: './input-common.component.html',
  styleUrl: './input-common.component.scss'
})
export class InputCommonComponent {
  @Input() label: string = ''; // Nhãn của input
  @Input() placeholder: string = ''; // Placeholder của input
  @Input() type: string = 'text'; // Kiểu input: text, number, email, etc.
  @Input() value: string | number = ''; // Giá trị của input
  @Input() required: boolean = false; // Yêu cầu input
  @Input() disabled: boolean = false; // Vô hiệu hóa input

  @Output() valueChange = new EventEmitter<string | number>(); // Phát sự kiện khi giá trị thay đổi

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.valueChange.emit(target.value);
  }
}
